import Print from './packages/print.js'
// import Print from './packages/printarea.js'

Print.install = function (Vue) {
  Vue.directive('print', Print)
}

export default Print



// WEBPACK FOOTER //
// ./src/utils/nbprint/index.js